import { useTranslation } from 'react-i18next';
import { Alert, Checkbox } from 'Components';
import { useFormikContext } from 'formik';
import { AddGroupValues } from 'Pages/Group/Group.types';

function AutoactivateField() {
	const { t } = useTranslation();
	return (
		<>
			<Checkbox.FormikField name="autoactivate">
				{t(`users.components.autoActiveModal.btnText`)}
			</Checkbox.FormikField>
		</>
	);
}

export default AutoactivateField;
